import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserFollowers } from '../../services/followService';
import supabase from '../../services/supabase';
import { FollowButton, Button } from '../../components/buttons';
import { isFollowingUser, followUser, unfollowUser } from '../../services/followService';

export default function FollowersList() {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [followingMap, setFollowingMap] = useState({});
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!username) {
      setError('User not found.');
      setLoading(false);
      return;
    }
    const fetchFollowers = async () => {
      setLoading(true);
      setError(null);
      // 1. Get user_id by username (case-insensitive)
      const { data: profile, error: profileError } = await supabase
        .from('user_profiles')
        .select('user_id, username')
        .ilike('username', username)
        .single();
      console.log('[FollowersList] Profile lookup:', profile, profileError);
      if (profileError || !profile) {
        setError('User not found.');
        setLoading(false);
        return;
      }
      // 2. Get followers by user_id
      const { data, error } = await getUserFollowers(profile.user_id);
      console.log('[FollowersList] Followers fetch:', data, error);
      if (error) {
        setError('Failed to fetch followers.');
        setLoading(false);
        return;
      }
      setFollowers(data || []);
      // 3. Check which followers you are following
      const map = {};
      for (const f of data || []) {
        map[f.profile.user_id] = await isFollowingUser(f.profile.user_id);
      }
      setFollowingMap(map);
      setLoading(false);
    };
    fetchFollowers();
  }, [username]);

  return (
    <div style={{ padding: '2rem', maxWidth: 500, margin: '0 auto', marginTop: '100px' }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24 }}>Followers</h2>
      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && followers.length === 0 && <p>No followers yet.</p>}
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {followers.map((f) => {
          const isFollowing = followingMap[f.profile.user_id];
          const profile = f.profile || {};
          return (
            <li
              key={f.id}
              className="user-list-card"
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'rgba(255,255,255,0.6)',
                borderRadius: 16,
                boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
                padding: '12px 20px',
                marginBottom: 16,
                transition: 'box-shadow 0.2s',
              }}
            >
              <div
                style={{ display: 'flex', alignItems: 'center', flex: 1, cursor: 'pointer' }}
                onClick={() => navigate(`/profile/${profile.username || ''}`)}
                title={`View ${profile.username || ''}'s profile`}
              >
                {profile.profilePicture ? (
                  <img
                    src={profile.profilePicture}
                    alt={profile.username}
                    className="avatar avatar-medium"
                    style={{ marginRight: 16 }}
                  />
                ) : (
                  <div className="avatar avatar-medium avatar-fallback" style={{ marginRight: 16 }}>
                    <span className="avatar-initial">{(profile.username || f.email || '?')[0]}</span>
                  </div>
                )}
                <span className="profile-username" style={{ fontSize: 18, fontWeight: 500 }}>
                  {profile.username || f.email || f.id}
                </span>
              </div>
              {isFollowing ? (
                <button
                  className="unfollow-button"
                  style={{ marginLeft: 16, backgroundColor: '#e63946', color: 'white', border: 'none', padding: '8px 18px', borderRadius: 16, fontWeight: 600, fontSize: 15, cursor: 'pointer', transition: 'all 0.3s ease' }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    const { error } = await unfollowUser(f.profile.user_id);
                    if (!error) {
                      setFollowingMap((prev) => ({ ...prev, [f.profile.user_id]: false }));
                    } else {
                      alert('Failed to unfollow.');
                    }
                  }}
                >
                  Unfollow
                </button>
              ) : (
                <button
                  className="follow-button"
                  style={{ marginLeft: 16, background: 'linear-gradient(135deg, #809CFF, #4285F4)', color: 'white', border: 'none', padding: '8px 18px', borderRadius: 16, fontWeight: 600, fontSize: 15, cursor: 'pointer', transition: 'all 0.3s ease' }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    const { error } = await followUser(f.profile.user_id);
                    if (!error) {
                      setFollowingMap((prev) => ({ ...prev, [f.profile.user_id]: true }));
                    } else {
                      alert('Failed to follow.');
                    }
                  }}
                >
                  Follow
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
} 